import React from 'react';
import { ChevronDown } from 'lucide-react';

/** Padding horizontal aligné sur le contenu des cartes (px-4). */
export const CARD_CONTENT_PX = 'px-4';

/** Classes du bouton accordéon en bas de carte (pleine largeur, alignement chevron à droite). */
export const CARD_FOOTER_TOGGLE_CLASS =
  'box-border w-full flex items-center justify-between gap-3 py-3.5 text-left border-t border-neutral-200/90 bg-blue-gray-50 hover:bg-blue-gray-100/90 active:bg-blue-gray-100 transition-colors';

/**
 * Bouton pleine largeur en bas d’une carte pour ouvrir un panneau de détail.
 * @param {boolean} [inset=false] — dans un parent déjà en px-4 : fond bord à bord, texte aligné au contenu
 */
export default function CardFooterToggle({
  label,
  badge = null,
  expanded = false,
  onClick,
  stopPropagation = false,
  inset = false,
  className = '',
}) {
  const pxClass = inset
    ? `${CARD_CONTENT_PX} -mx-4 w-[calc(100%+2rem)] max-w-[calc(100%+2rem)]`
    : CARD_CONTENT_PX;

  return (
    <button
      type="button"
      onClick={(e) => {
        if (stopPropagation) e.stopPropagation();
        onClick?.(e);
      }}
      className={`${CARD_FOOTER_TOGGLE_CLASS} ${pxClass} ${className}`.trim()}
      aria-expanded={expanded}
    >
      <span className="flex items-center gap-2 min-w-0 text-left">
        <span className="text-sm font-medium text-blue-gray-800 leading-none">{label}</span>
        {badge}
      </span>
      <ChevronDown
        size={16}
        className={`text-blue-gray-400 shrink-0 transition-transform ${expanded ? 'rotate-180' : ''}`}
        aria-hidden
      />
    </button>
  );
}
